/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";
interface Props {
	onBack?: () => void;
}
const FineTunningHeader = ({ onBack }: Props) => {
	const { t } = useTranslation();
	return (
		<div className="bg-white border-b border-slate-200 px-8 py-2.5 shrink-0 shadow-sm">
			<div className="flex items-center gap-6 mb-2">
				<button
					onClick={onBack}
					className="w-10 h-10 rounded-xl border border-slate-200 flex items-center justify-center text-slate-400 hover:text-orange-500 hover:bg-orange-50 transition-all"
				>
					<span className="material-symbols-outlined text-xl">
						{t("mediaBatchInit.finalQuality.arrow_back")}
					</span>
				</button>
				<div className="flex items-center gap-10">
					<h2 className="text-xl font-black text-[#2D3E50] tracking-tight">
						{t("mediaBatchInit.fineTuning.processFineTuning")}
					</h2>
					<div className="flex items-center gap-3">
						<div className="w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center">
							<span className="material-symbols-outlined text-xs font-black">
								{t("mediaBatchInit.finalQuality.check")}
							</span>
						</div>
						<div className="w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center">
							<span className="material-symbols-outlined text-xs font-black">
								{t("mediaBatchInit.finalQuality.check")}
							</span>
						</div>
						<div className="w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center">
							<span className="material-symbols-outlined text-xs font-black">
								{t("mediaBatchInit.finalQuality.check")}
							</span>
						</div>
						<div className="w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center">
							<span className="material-symbols-outlined text-xs font-black">
								{t("mediaBatchInit.finalQuality.check")}
							</span>
						</div>
						<div className="w-7 h-7 rounded-full bg-[#2D3E50] text-white flex items-center justify-center text-[10px] font-black ring-4 ring-slate-100">
							5
						</div>
						<div className="w-7 h-7 rounded-full bg-slate-100 text-slate-300 flex items-center justify-center text-[10px] font-black">
							6
						</div>

						<div className="ml-6 flex flex-col">
							<span className="text-[7px] font-black text-orange-500 uppercase tracking-[0.2em] leading-none">
								{t("mediaBatchInit.fineTuning.activePhase")}
							</span>
							<span className="text-[9px] font-black text-[#2D3E50] uppercase tracking-wider">
								{t("mediaBatchInit.fineTuning.finalVerficationAndAudit")}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FineTunningHeader;
